import queryString from 'query-string';

const sort = (a, b) => a.localeCompare(b);

export default (params) =>
  queryString.stringify(params, {
    arrayFormat: 'repeat',
    sort,
  });
